/** @jsxRuntime classic */
/** @jsx jsx */
/** @jsxFrag React.Fragment */
import { jsx } from "@emotion/react";
import InsertInvitationOutlined from "@material-ui/icons/InsertInvitationOutlined";
import React from "react";

import { DetailedSearchCalendar } from "./components/DetailedSearchCalendar";
import {
  backdropStyle,
  dateInputStyle,
  iconStyle,
  inputContainerStyle,
} from "./styles";
import { useThis } from "./useThis";

import type { Props } from "./props";

export const DateInput: React.FC<Props> = (props) => {
  const { maxDate, minDate, placeholder, selectedDate } = props;
  const {
    applyCalendarContainerStyle,
    formatDisplayDate,
    handleChange,
    handleDateSelect,
    handleKeyDown,
    handleShowDatepicker,
    inputRef,
    setShowCalendar,
    showCalendar,
  } = useThis(props);

  return (
    <>
      <div css={inputContainerStyle}>
        <input
          ref={inputRef}
          css={dateInputStyle}
          type="text"
          value={selectedDate ? formatDisplayDate(selectedDate.getTime()) : ""}
          placeholder={placeholder}
          onChange={handleChange}
          onClick={handleShowDatepicker}
          onKeyDown={handleKeyDown}
        />
        <InsertInvitationOutlined css={iconStyle} />
      </div>

      {showCalendar && (
        <>
          <div css={applyCalendarContainerStyle}>
            <DetailedSearchCalendar
              selectedDate={selectedDate}
              maxDate={maxDate}
              minDate={minDate}
              onDateSelect={handleDateSelect}
            />
          </div>

          <div
            css={backdropStyle}
            onClick={() => {
              setShowCalendar(false);
            }}
          />
        </>
      )}
    </>
  );
};
